module.exports = __webpack_public_path__ + "static/media/new-tile-bg.ecf53162.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-tile-bg.jpg
// module id = 1211
// module chunks = 0